import React from "react";
import vector from '../Images/Vector1.png'
import vecto from '../Images/Vector2.png'
import vect from '../Images/Vector3.png'
import vec from '../Images/Laptop.png'
import ve from '../Images/Mobilephone.png'
import { motion } from "framer-motion";
import {FaArrowRight } from "react-icons/fa";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";



const Sectwo = () => {

    const navigate = useNavigate();

    const background = {
        background: '#EEEE',
    }

    const fadeUp = {
        initial: { opacity: 0, y: 80 },
        whileInView: { opacity: 1, y: 0 },
        transition: { duration: 0.8 },
        viewport: { once: true }
    }

    return(
        <>
        <div style={background}>
        <div className="container">

        <div className="row">
            <motion.div 
            className="col-md-12 text-center"
            initial={{ opacity: 0, y: -40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            >
                <div style={{marginTop: '70px'}}>
                    <h3 style={{fontSize: '30px', fontWeight: '700'}}>Our Core Expertise</h3>
                    <p>
                        Transforming complex challenges into streamlined digital experiences 
                        <br /> with our specialized service suites.
                    </p>
                </div>
            </motion.div>
        </div>

        <div className="row g-4 mt-5 align-items-center">

        <motion.div className="col-md-4" {...fadeUp}>
            <div className="card hover-card">
                <div className="img-wrapper">
                    <img src={vector} alt="" className="img-fluid img" />
                </div>
                <h1 className="mt-4 title">Logo & Brand Identity</h1>
                <p className="mt-5">
                    Crafting unique visual identities that resonate with your market and establish lasting trust.
                </p>
                <motion.div whileHover={{ y: -5 }} transition={{ type: "spring", stiffness: 400, damping: 10 }}>
                <Link to="/about" className="mt-4 learn-more d-inline-flex align-items-center gap-2">
                    Learn more <FaArrowRight />
                </Link>
                </motion.div>
            </div>
        </motion.div>

        <motion.div className="col-md-4" {...fadeUp}>
            <div className="card hover-card">
            <img src={vecto} alt="" className="img-fluid img" />
            <h1 className="mt-4 title">Website Development</h1>
            <p className="mt-5">
                High performance web platforms built for speed, conversion and impeccable user experience
            </p>

            <motion.div whileHover={{ y: -5 }} transition={{ type: "spring", stiffness: 400, damping: 10 }}>
            <Link to="/about" className="mt-4 learn-more d-inline-flex align-items-center gap-2">
                Learn more <FaArrowRight />
            </Link>
            </motion.div>
            </div>
        </motion.div>

        <motion.div className="col-md-4" {...fadeUp}>
            <div className="card hover-card">
            <img src={vect} alt="" className="img-fluid img" />
            <h1 className="mt-3 title">AI Solutions</h1>
            <p className="mt-4">
                Unlocking efficiency through machine learning and automated workflows tailored to your operational needs.
            </p>

            <motion.div whileHover={{ y: -5 }} transition={{ type: "spring", stiffness: 400, damping: 10 }}>
            <Link to="/about" className="mt-4 learn-more d-inline-flex align-items-center gap-2">
                Learn more <FaArrowRight />
            </Link>
            </motion.div>
            </div>
        </motion.div>

        <motion.div className="col-md-4 pb-5" {...fadeUp}>
            <div className="card hover-card">
            <img src={vec} alt="" className="img-fluid img" />
            <h1 className="mt-3 title">Software Development</h1>
            <p className="mt-4">
                Scalable enterprise-grade application designed to solve specific business problems
            </p>

            <motion.div whileHover={{ y: -5 }} transition={{ type: "spring", stiffness: 400, damping: 10 }}>
            <Link to="/about" className="mt-4 learn-more d-inline-flex align-items-center gap-2">
                Learn more <FaArrowRight />
            </Link>
            </motion.div>
            </div>
        </motion.div>

        <motion.div className="col-md-4 pb-5" {...fadeUp}>
            <div className="card hover-card">
            <img src={ve} alt="" className="img-fluid img" />
            <h1 className="mt-3 title">Mobile App Development</h1>
            <p className="mt-4">
                Next-generation Native and cross-platform mobile experiences for iOS and Android.
            </p>

            <motion.div whileHover={{ y: -5 }} transition={{ type: "spring", stiffness: 400, damping: 10 }}>
            <Link to="/about" className="mt-4 learn-more d-inline-flex align-items-center gap-2">
                Learn more <FaArrowRight />
            </Link>
            </motion.div>
            </div>
        </motion.div>

        <motion.div className="col-md-4 pb-5" {...fadeUp}>
        <div className="text-center need">
            <h1 className="title" style={{ marginTop: '50px' }}>
            Need a custom Solution?
            </h1>
            <p className="mt-4">
            Let’s discuss your unique project requirements.
            </p>
            <div className="d-flex justify-content-center mt-3 mb-5">
            <button className="butt text-center" onClick={() => navigate("/contact")}>
                Talk to us
            </button>
            </div>
        </div>
        </motion.div>

        </div>
        </div>            
        </div>
        </>
    )
}

export default Sectwo;